export default (params) => ({
  trigger: {
    name: 'feedback_element.select_open_answer',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'ar',
          'after_order',
          'trade-in',
          'return',
          'other',
          'advice',
        ],
      },
    },
    event: {
      name: 'select_input_field',
      params: {
        input_field: 'open_answer',
        status: 'focus',
        content: null,
      },
    },
  },
});
